import { useEffect, useState } from 'react';
import { CommonHelper } from 'src/utils/commonHelper';
import FacebookPostPreview from './facebook-post-preview.component';
import FacebookReelsPreview from './facebook-reels-preview.component';
import FacebookStoryPreview from './facebook-story-preview.component';

const FacebookPreviewOrganize = ({ postType, previewData, profileId }) => {
  const [data, setData] = useState({});
  useEffect(() => {
    if (!previewData || !profileId) return;
    let data = previewData[profileId].data;
    for (var i = 0; i < data.length; i++) {
      if (data[i].post_type === postType) {
        data[i].media_data = CommonHelper.ProcessMediaUrl(data[i].media_url);
        setData(data[i]);
      }
    }
  }, [postType, previewData, profileId]);

  return (
    <>
      {data && data?.post_type === 'post' && <FacebookPostPreview data={data} />}
      {data && data?.post_type === 'reels' && <FacebookReelsPreview data={data} />}
      {data && data?.post_type === 'story' && <FacebookStoryPreview data={data} />}
    </>
  );
};

export default FacebookPreviewOrganize;
